import React, { useEffect, useState } from 'react';

const DESKTOP_LOOPBACK_CALLBACK = 'http://127.0.0.1:53682/oauth/callback';
const ANDROID_DEEP_LINK = 'in.restroai.lite://oauth/callback';

function isMobileUserAgent() {
  return /Android|iPhone|iPad|Mobile/i.test(navigator.userAgent || '');
}

/**
 * Google OAuth redirect for PocketBillingAI.
 * - Phone: restroai.in → deep link into the app
 * - Desktop: restroai.in → local Electron listener
 */
export default function LiteOAuthCallbackPage() {
  const [status, setStatus] = useState('Completing Google sign-in…');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const error = params.get('error_description') || params.get('error');
    const query = window.location.search || '';

    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(
        { type: 'restro-oauth-code', code, error: error || null },
        '*'
      );
      setStatus('Sign-in sent to PocketBillingAI. You can close this tab.');
      return;
    }

    if (code || error) {
      if (isMobileUserAgent()) {
        setStatus('Opening PocketBillingAI on your phone…');
        window.location.replace(`${ANDROID_DEEP_LINK}${query}`);
      } else {
        setStatus('Returning to PocketBillingAI on your computer…');
        window.location.replace(`${DESKTOP_LOOPBACK_CALLBACK}${query}`);
      }
      return;
    }

    setStatus('Missing sign-in data. Close this tab and try again from PocketBillingAI → Sync.');
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        fontFamily: 'system-ui, sans-serif',
        color: '#44403c',
        textAlign: 'center',
      }}
    >
      <div>
        <p style={{ fontSize: 18, marginBottom: 8 }}>PocketBillingAI</p>
        <p style={{ fontSize: 14 }}>{status}</p>
        <p style={{ fontSize: 12, marginTop: 16, color: '#78716c' }}>
          If nothing happens, open PocketBillingAI and try Sign in again from the Sync tab.
        </p>
      </div>
    </div>
  );
}
